import { render, staticRenderFns } from "./main.empresas.vue?vue&type=template&id=77965d79"
import script from "./main.empresas.vue?vue&type=script&lang=js"
export * from "./main.empresas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports